import React from "react";
import { Box, Stack } from "@mui/material";

const PlayerStatPill = ({ waglScore = '??', handicap = '??'}) => {
  return (
    <Stack direction="row" spacing={0} sx={{ justifyContent: 'center' }}>
      <Box
        sx={{
          bgcolor: '#B299FF',
          color: '#fff',
          borderRadius: '50% 0 0 50%',
          p: '2px 5px',
          fontSize: 10,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {typeof waglScore === 'number' ? Math.round(waglScore) : waglScore}
      </Box>
      <Box
        sx={{
          bgcolor: '#A6E35B',
          color: '#183A1D',
          borderRadius: '0 50% 50% 0',
          p: '2px 5px',
          fontSize: 10,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {handicap}
      </Box>
    </Stack>
  )
}

export default PlayerStatPill;